//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
      required: false,
    },
    fileName: {
      type: String,
      required: false,
    },
    text: {
      type: String,
      required: false,
      default: '',
    },
    url: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: '',
      required: false,
    },
    extension: {
      type: String,
      required: false,
    },
    size: {
      type: Number,
      required: false,
    },
    thumbnail: {
      type: String,
      required: false,
      default: null,
    },
    thumbnailWebp: {
      type: String,
      required: false,
      default: null,
    },
    type: {
      type: String,
      default: 'TeaserDownload',
    },
  },
  computed: {
    isUrlRelative() {
      return this.url.search('^http(s|):\\/\\/') === -1
    },
    image() {
      if (!this.thumbnail) return
      return {
        src: this.thumbnail.replace(
          '/resize=fit:crop,height:290,width:200/output=format:png/',
          '/output=format:png/resize=fit:crop,height:290,width:200/'
        ),
        src_webp: this.thumbnailWebp.replace(
          '/resize=fit:crop,height:290,width:200/output=format:webp/',
          '/output=format:webp/resize=fit:crop,height:290,width:200/'
        ),
      }
    },
  },
}
